import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const StyledUrlReadOnlyWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  gap: 10px;
`;

export const StyledUrlReadOnlyCopyBtn = styled.div`
  display: flex;
  flex: 1;
  border-radius: 5px;
  min-height: 36px;
  border: 1px solid ${GrayColors["G-1-5"]};
  background-color: ${GrayColors["G-0-5"]};

  span {
    display: flex;
    width: 100%;
    font-weight: 600;
    cursor: pointer;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledUrlReadOnlySection = styled.div`
  display: flex;
  align-items: center;
  flex: 6;
  min-width: 0;
  padding-left: 11px;
  padding-right: 10px;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 5px;
  min-height: 36px;
`;

export const StyledUrlReadOnlyInput = styled.input`
  width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  line-height: 18px;
  color: inherit;
  cursor: text;
  text-overflow: ellipsis;
`;
